import { render, staticRenderFns } from "./td-destroy.vue?vue&type=template&id=1998091f&scoped=true&lang=pug"
import script from "./td-destroy.vue?vue&type=script&lang=js"
export * from "./td-destroy.vue?vue&type=script&lang=js"
import style0 from "./td-destroy.vue?vue&type=style&index=0&id=1998091f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998091f",
  null
  
)

export default component.exports